export enum TooltipPositions {
  TOP = 'top',
  BOTTOM = 'bottom',
}
